import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { createSymbolLpEpic } from './_epic/createSymbolLp.epic';
import { updateSymbolLpEpic } from './_epic/updateSymbolLp.epic';
import { removeSymbolLpEpic } from './_epic/removeSymbolLp.epic';
import { startSymbolLpProcessingEpic } from './_epic/startSymbolLpProcessing.epic';
import { endSymbolLpProcessingEpic } from './_epic/endSymbolLpProcessing.epic';
import { loadSymbolLpEpic } from './_epic/loadSymbolLp.epic';
import { loadSymbolLpListEpic } from './_epic/loadSymbolLpList.epic';
import { loadUnmappedSymbolsEpic } from './_epic/loadUnmappedSymbols.epic';
import { exportLpSymbolsEpic } from './_epic/exportLpSymbols.epic';
import { bulkUpdateSymbolLpEpic } from './_epic/bulkUpdateSymbolLp.epic';
import { bulkRemoveSymbolLpEpic } from './_epic/bulkRemoveSymbolLp.epic';

export const symbolLpEpic = safeCombineEpics(
  createSymbolLpEpic,
  updateSymbolLpEpic,
  removeSymbolLpEpic,
  loadSymbolLpEpic,
  loadSymbolLpListEpic,
  loadUnmappedSymbolsEpic,
  startSymbolLpProcessingEpic,
  endSymbolLpProcessingEpic,
  exportLpSymbolsEpic,
  bulkUpdateSymbolLpEpic,
  bulkRemoveSymbolLpEpic,
);
